import { useMemo } from "react";
import { PSelect, Select } from "./Select";

type PMerchantsSelect<T extends object> = {
  listOfValues: T[];
  value: PSelect["value"];
  onChange: PSelect["onChange"];
  label: string;
  color: string;
  baseColor: string;
  borderColor: string;
  expandedBorderColor?: string;
  currentId?: number;
};

interface IBaseMerchant {
  id: number;
  name: string;
}

export const MerchantDropdown = <T extends IBaseMerchant>(
  props: PMerchantsSelect<T>
) => {
  const {
    listOfValues,
    value,
    onChange,
    label,
    color,
    baseColor,
    borderColor,
    expandedBorderColor,
    currentId,
  } = props;

  const options = useMemo(() => {
    return listOfValues.map((item) => ({
      label: (
        <div className="flex flex-row justify-between w-full">
          <div className="flex items-center gap-[10px]">
            <span className={`text-[14px]`}>{item.name}</span>
          </div>
        </div>
      ),
      value: item.id,
    }));
  }, [listOfValues]);

  return (
    <Select
      label={label}
      options={options}
      value={value}
      color={color}
      borderColor={borderColor}
      baseColor={baseColor}
      expandedBorderColor={expandedBorderColor}
      onChange={(val: any) => onChange && onChange(val)}
      getOptionCls={(isActive: any) =>
        isActive
          ? "text-text-navbar-active text-[14px]"
          : "text-text-base text-[14px]"
      }
      optionsHeader={
        <div className="w-full flex flex-row justify-between text-grayscale-4 text-[14px] cursor-default"></div>
      }
    />
  );
};
